import React from 'react';
import styled from '@emotion/styled';
import { IconContext, DefaultContext } from './IconContext.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Tree2Element(tree) {
  return tree && tree.map((node, i) => React.createElement(node.tag, __spreadValues({ key: i }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  const IconWrapper = (props) => /* @__PURE__ */ React.createElement(IconBase, __spreadValues({
    attr: __spreadValues({}, data.attr)
  }, props), Tree2Element(data.child));
  return IconWrapper;
}
function IconBase(props) {
  const elem = (conf) => {
    const computedSize = props.size || conf.size || "1em";
    let className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    const _a = props, { attr, color } = _a, svgProps = __objRest(_a, ["attr", "color"]);
    return /* @__PURE__ */ React.createElement(StyledSVG, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      fill: "currentColor",
      strokeWidth: props.strokeWidth ? typeof computedSize === "number" && computedSize >= 24 ? computedSize <= 40 ? 1.5 : 2 : 1 : void 0
    }, conf.attr), attr), svgProps), {
      className,
      style: __spreadValues(__spreadValues({}, conf.style), props.style),
      color,
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), props.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}
const SvgCss = ({ color, theme }) => {
  var _a, _b;
  return `
  path[stroke],
  rect[stroke],
  line {
    stroke: ${color ? ((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a[color]) || color : ""};
  }
  path:not([stroke]),
  rect:not([stroke]) {
    fill: ${color ? ((_b = theme == null ? void 0 : theme.colors) == null ? void 0 : _b[color]) || color : ""};
  }
`;
};
const StyledSVG = styled.svg`
  ${SvgCss};
`;

export { GenIcon, IconBase, SvgCss };
